export default __webpack_public_path__ + "static/media/MaximMerchant-v2.11.4.5c727d46.apk";